export function atlasErrorMessage(err: unknown): string {
  if (!err || typeof err !== 'object') return 'Something went wrong.';
  const e = err as { code?: string; message?: string };
  const code = String(e.code || '').toLowerCase();
  const msg = String(e.message || '').trim();
  if (
    code.includes('not-found') ||
    code.includes('unimplemented') ||
    msg.toLowerCase() === 'internal' ||
    msg.toLowerCase() === 'not found'
  ) {
    return 'Atlas Cloud Functions are not reachable (not deployed yet, or Cloud Run blocked the call). Deploy the atlas functions, then retry Test GitHub.';
  }
  return msg || 'Something went wrong.';
}
